
import { defineComponent } from 'vue'

import Hero from '@/assets/heroes/home-hero.svg?inline'

export default defineComponent({
  name: 'AppHero',
  components: {
    Hero,
  },
})
